export { ObjectChainValue as default } from 'choerodon-ui/dataset';
